// extracted by mini-css-extract-plugin
module.exports = {"main":"Maintenance_main__hvzeC","maintenance":"Maintenance_maintenance___bZGm","image":"Maintenance_image__7FvHG","body":"Maintenance_body__XbA1S","logo":"Maintenance_logo__n1jJk"};